export default {
  // #region首页
  main_collection_function: '收藏功能',
  main_menu_bar_management: '菜单栏管理',
  // #endregion

  // #region 菜单
  // #region 下载中心
  main_menu_download_center: '下载中心',
  // #endregion
  // #region 客服系统菜单
  main_menu_icms_system: '客服系统',
  main_menu_icms_Intelligent_system: '智能客服系统',
  main_menu_icms_work_order: '客服工单',
  main_menu_icms_create_work_order: '创建工单',
  main_menu_icms_order_list: '工单列表',
  main_menu_icms_task_list: '任务列表',
  main_menu_icms_export_order_list: '导入结果查询',
  main_menu_icms_export_order_list_details: '导入结果查询详情',
  main_menu_icms_template_settings: '模板设置',
  main_menu_icms_route_management: '路由管理',
  main_menu_icms_factor_list: '因子管理',
  main_menu_icms_basic_data_list: '基础数据维护',
  main_menu_icms_task_list_detail: '任务列表详情',
  main_menu_icms_order_list_detail: '工单列表详情',
  main_menu_icms_mission_list_detail: '任务详情',
  main_menu_icms_payment_order_detail: '理赔详情',
  main_menu_icms_yun_order_detail: '小云工单详情',
  main_menu_icms_import_payment_order_detail: '导入理赔结果查询详情',
  main_menu_icms_data_report: '数据报表',
  main_menu_icms_status_flow_report: '状态流转表',
  main_menu_icms_issue_type_report: '问题类型统计表',
  main_menu_icms_source_report: '来源统计表',
  main_menu_icms_work_order_reply_report: '工单回复统计表',
  main_menu_icms_process_management: '流程管理',
  main_menu_icms_process_update: '流程编辑',
  main_menu_icms_process_create: '流程新增',
  main_menu_icms_process_view: '流程查看',
  main_menu_icms_process_ticket: '快捷查单',
  main_menu_icms_my_work_order: '我的工单',
  main_menu_icms_oversea_piece: '海外段工单',
  main_menu_icms_other_piece: '其他工单',
  main_menu_icms_advice_complaint: '咨询/查件/投诉',
  main_menu_icms_work_question: '问题件',
  main_menu_icms_advice_complaint_details: '咨询/查件/投诉详情',
  // #endregion
  // #region 消息投递菜单
  main_menu_middleware: '中间件',
  main_menu_middleware_message_delivery: '消息投递',
  main_menu_middleware_message_subscribe: '消息服务监控',
  main_menu_middleware_message_topic: '消息主题',
  main_menu_middleware_terminal: '终端管理',
  main_menu_middleware_loserate: '消息主题详情',
  // #endregion
  // #region 数据分发
  main_menu_middleware_data_distribution: '数据分发',
  main_menu_middleware_dataSourceList: '订阅列表',
  main_menu_middleware_api_route: 'API路由管理',
  // #endregion
  // #region 资源管理
  main_menu_rcms_resource_management: '资源管理',
  main_menu_rcms_channel_manage: '渠道管理',
  main_menu_rcms_delivery_manage: '派送渠道管理',
  main_menu_rcms_area_manage: '场地资源管理',
  main_menu_rcms_operating_outlet: '操作网点管理',
  main_menu_rcms_airport: '机场管理',
  main_menu_rcms_harbor: '港口管理',
  main_menu_rcms_port: '口岸管理',
  main_menu_rcms_transport_manage: '运力资源管理',
  main_menu_rcms_air_manage: '空运资源管理',
  main_menu_rcms_car_manage: '车辆管理',
  main_menu_rcms_push_record: '推送记录',
  main_menu_rcms_export_detail: '导出详情',
  // #endregion
  // #region 日志监控
  main_menu_server_log_monitor: '日志监控',
  main_menu_server_audit_log: '审计日志',
  main_menu_server_business_log: '业务日志',
  main_menu_server_application_log: '应用日志',
  // #endregion
  // #region 用户中心
  main_menu_usercenter_system: '用户中心管理系统',
  main_menu_usercenter: '用户中心',
  main_menu_usercenter_notice_manage: '公告与消息管理',
  // #endregion
  // #region 权限管理
  main_menu_permission_title: '权限管理',
  main_menu_permission_site_authorization: '网站权限管理',
  main_menu_permission_clients_menu: '菜单和按钮管理',
  main_menu_permission_role: '角色管理',
  main_menu_permission_dimension: '数据权限',
  main_menu_permission_site_userControl: '用户列表',
  main_menu_permission_user_authorization: '用户授权管理',
  main_menu_permission_resource_management: '数据资源管理',
  main_menu_permission_operation_log_permission: '操作日志-权限',
  main_menu_permission_user_import: '用户批量导入',
  // #endregion
  // #region 网站管理
  main_menu_permission_menu_manage: '网站管理',
  main_menu_permission_menu_list: '网站菜单管理',
  main_menu_permission_route_list: '网站页面管理',
  // #endregion
  // #region 用户管理
  main_menu_permission_user_management: '用户管理',
  main_menu_permission_post_manager: '职位管理',
  main_menu_permission_user_login_log: '用户登录日志',
  main_menu_permission_operation_log_employee: '操作日志-用户',
  // #endregion
  // #region 组织机构管理
  main_menu_permission_organization_management: '组织机构管理',
  main_menu_permission_subtree: '子树管理',
  main_menu_permission_subtree_detail: '子树管理详情',
  main_menu_permission_signing_node_belongs: '节点所属签约主体',
  main_menu_permission_base_organization: '基础树管理',
  main_menu_permission_operation_log_institution: '操作日志-组织机构',
  main_menu_permission_resource_detail: '资源授权',
  main_menu_permission_role_details: '角色详情页',
  main_menu_permission_role_resource_authorization: '角色资源授权',
  main_menu_permission_role_authorization: '角色授权管理',
  // #endregion
  // #region 基础数据
  main_menu_basicdata_title: '基础数据',
  main_menu_basicdata_table_meta_data: '表元数据',
  main_menu_basicdata_word_statistics: '词条统计',
  main_menu_basicdata_word_manage: '词条管理',
  main_menu_basicdata_public_manage: '基础数据列表',
  main_menu_basicdata_key_manage: '秘钥管理',
  main_menu_basicdata_web_wordstatistics: '前端词条统计',
  main_menu_basicdata_web_wordmanage: '前端词条管理',
  // ==== 基础数据ant =====
  main_menu_antbasicdata_title: '基础数据(ant)',
  main_menu_antbasicdata_table_meta_data: '表元数据',
  main_menu_antbasicdata_word_statistics: '词条统计',
  main_menu_antbasicdata_word_manage: '词条管理',
  main_menu_antbasicdata_public_manage: '基础数据列表',
  main_menu_antbasicdata_key_manage: '秘钥管理',
  main_menu_antbasicdata_web_wordstatistics: '前端词条统计',
  main_menu_antbasicdata_web_wordmanage: '前端词条管理',
  // #endregion
  // #region 小云工单
  main_menu_business_title: '小云工单',
  main_menu_business_workorder: '小云工单列表',
  main_menu_business_form_type: '小云工单类型',
  main_menu_business_form_template: '小云工单表单模板库',
  main_menu_business_route: '小云工单路由规则',
  main_menu_business_staffs: '小云工单成员管理',
  main_menu_business_schedule: '小云工单工作日配置',
  main_menu_business_report_title: '小云工单统计信息',
  main_menu_business_report_order: '工单统计信息',
  main_menu_business_export_order: '工单导出信息',
  main_menu_business_statistics: '工单详情信息',
  main_menu_business_notice: '小云工单公告',
  // #endregion
  // #region 运维工单
  main_menu_business_owos_ops: '运维工单',
  main_menu_business_owos_ops_form_type: '运维工单类型',
  main_menu_business_owos_ops_form_template: '运维工单表单模板库',
  main_menu_business_owos_ops_workorder: '运维工单列表',
  main_menu_business_owos_ops_route: '运维工单路由规则',
  main_menu_business_owos_ops_staffs: '运维工单成员管理',
  main_menu_business_owos_ops_report: '运维工单统计信息',
  // #endregion
  // #region 需求管理
  main_menu_business_require_management: '需求管理',
  main_menu_business_require_create: '创建需求',
  main_menu_business_require_kanban: '需求看板',
  main_menu_business_require_business: '业务需求池',
  main_menu_business_require_product: '产品需求池',
  main_menu_business_require_record: 'TAPD流转记录',
  main_menu_business_require_help: '帮助中心',
  main_menu_business_require_detail: '需求详情',
  main_menu_business_require_edit: '编辑需求',
  main_menu_business_require_system: '需求系统管理',
  main_menu_business_require_organization: '需求组织结构',
  main_menu_business_require_people: '需求人员管理',
  // #endregion
  // #region 服务器管理
  main_menu_server_list: '服务器管理',
  // #endregion
  // #region 服务商账号管理
  main_menu_ctms_title: '服务商账号管理',
  main_menu_ctms_account_manage: '账号管理',
  main_menu_ctms_login_log: '登录日志',
  // #endregion
  // #region 航空提货
  main_menu_ctms_air_delivery: '航空提货',
  main_menu_ctms_port_delivery: '进港提货',
  main_menu_ctms_order_manage: '提单管理',
  main_menu_ctms_NOA_manage: 'NOA管理',
  main_menu_ctms_pickup_task_manage: '进港提货任务管理',
  main_menu_ctms_exception_manage: '进港提货异常管理',
  main_menu_ctms_backlog_manage: '航空提货待办任务',
  // #endregion
  // #region 资源组管理
  main_menu_resource_title: '资源组管理',
  main_menu_resource_workbench: '资源组工作台',
  main_menu_resource_cost_board: '资源成本看板',
  main_menu_resource_application_modify: '资源申请',
  main_menu_resource_apply_list: '资源申请列表',
  main_menu_resource_group_details: '资源申请详情',
  main_menu_resource_hardware_specification: '硬件配置管理',
  main_menu_resource_middleware_type: '中间件类型管理',
  main_menu_resource_entrypoint: '接入点管理',
  main_menu_resource_load_balancer: '负载均衡器',
  main_menu_resource_cluster: '集群管理',
  main_menu_resource_environment: '环境管理',
  main_menu_resource_middleground: '研发中心',
  main_menu_resource_system: '系统管理',
  main_menu_resource_system_detail: '系统资源详情',
  main_menu_resource_preview: '资源预览页',
  // #endregion
  // #region Deploy3
  main_menu_deploy_title: 'Deploy3',
  main_menu_deploy_real_time: '部署实时统计',
  main_menu_deploy_statistics: '部署统计',
  main_menu_deploy_application: '应用管理',
  main_menu_deploy_deployment: '部署管理',
  main_menu_deploy_deployment_detail: '部署详情',
  main_menu_deploy_relationship: '关系管理',
  main_menu_deploy_deployment_status: '部署状态',
  main_menu_deploy_frontend_deploy: '前端包管理网站',
  main_menu_deploy_frontend_deploy_detail: '前端包管理详情',
  main_menu_deploy_app_manage_system: '系统信息',
  // #endregion
  // #region 轨迹管理-tis
  main_menu_tis_new_trajectory_system: '新版TIS轨迹系统',
  main_menu_tis_title: '轨迹管理',
  main_menu_tis_search: '轨迹查询',
  main_menu_tis_track_query_list: '轨迹查询列表',
  main_menu_tis_track_archiving: '归档轨迹查询',
  main_menu_tis_add_track_approval: '编辑轨迹审核',
  main_menu_tis_track_repair_result: '轨迹修复结果查询',
  main_menu_tis_aging_standard: '标准时效配置',
  main_menu_tis_monitor_statistics: '轨迹节点监控',
  main_menu_tis_numbers_relation: '轨迹单号关联',
  main_menu_tis_dataDownload: 'TIS数据下载中心',
  main_menu_tis_unmatcNode: '未匹配节点查询',
  main_menu_tis_configuration_management: '轨迹配置管理',
  main_menu_tis_facilitator: 'TIS服务商管理',
  main_menu_tis_channel: 'TIS渠道管理',
  main_menu_tis_tracking_node: '轨迹节点管理',
  main_menu_tis_track_business: '轨迹业务阶段管理',
  main_menu_tis_track_examine: '服务商轨迹规则审核',
  main_menu_tis_track_subscription_managemeent: '轨迹订阅管理',
  main_menu_tis_track_query_listDes: '操作事件详情',
  main_menu_tis_track_query_listDesOut: '外部轨迹详情',
  main_menu_tis_track_view_fbaChild: '查看FBA子单',
  main_menu_tis_channel_relation: '装箱渠道与TIS渠道关联',
  main_menu_tis_node_deployment: 'TIS与LTS节点配置',
  main_menu_tis_track_config: '轨迹策略配置',
  main_menu_tis_awb_query: '云颂轨迹查询',
  main_menu_tis_awb_detail: '云颂轨迹详情',
  main_menu_tis_awb_management: '云颂轨迹管理',
  main_menu_tis_track_notification: '轨迹通知管理',
  main_menu_tis_report_analysis: '轨迹报表分析',
  main_menu_tis_timeliness_report: '轨迹及时率报表',
  main_menu_tis_timeliness_details: '及时率异常明细',
  main_menu_tis_general_query: '轨迹通用查询',
  main_menu_tis_push_config: '轨迹对外配置',
  main_menu_tis_push_monitor: '轨迹推送监控',
  main_menu_tis_flight_info: '航班信息配置',
  // #endregion
  // #region 工作台管理
  main_menu_wfs_work_system: '工作台系统',
  main_menu_wfs_title: '工作台管理',
  main_menu_wfs_workbench_management: '后端管理',
  main_menu_wfs_module_manage: '模块管理',
  main_menu_wfs_data_manage: '数据流管理',
  main_menu_wfs_shortcut_manage: '快捷入口管理',
  main_menu_wfs_system_setting: '系统设置',
  main_menu_wfs_type_manage: '业务类型管理',
  main_menu_wfs_priority_manage: '优先级管理',
  main_menu_wfs_config_center: '配置中心',
  main_menu_wfs_message_record: '站内信记录查询',
  main_menu_wfs_station_message: '站内信管理',
  main_menu_wfs_saturation_factor: '饱和率配置',
  main_menu_wfs_items: '事项配置',
  main_menu_wfs_dictionary: '数据配置',
  main_menu_wfs_clearance_manager: '清关单证管理者',
  main_menu_wfs_batch_process: '批量处理',
  main_menu_wfs_complaint_deal: '转办处理',
  main_menu_wfs_todo_center: '待办中心',
  main_menu_wfs_message: '消息提醒',
  main_menu_wfs_create_quick: '创建快捷',
  main_menu_wfs_quick_setting: '快捷入口设置',
  // #endregion
  // #region 工单系统
  main_menu_wos_title: '工单系统',
  main_menu_wos_workbench: '工作台',
  main_menu_wos_rule: '基础数据维护',
  main_menu_wos_import_result: '导入结果查询',
  main_menu_wos_work_type: '工单类型维护',
  main_menu_wos_question: '问题件工单',
  main_menu_wos_add_rule: '添加规则',
  main_menu_wos_import_detail: '导入详情',
  main_menu_wos_import_result_detail: '导入结果明细',
  main_menu_wos_qs_order_detail: '问题件工单详情',
  main_menu_wos_no_forest_order_detail: '无预报工单详情',
  main_menu_wos_forest_order_detail: '预报工单详情',
  main_menu_wos_custom_order_detail: '关务工单详情',
  main_menu_wos_bill_order_detail: '计费问题件工单详情',
  main_menu_wos_ots_order_detail: 'OTS无数据工单详情',
  main_menu_wos_return_order_detail: '海外退件工单详情',
  main_menu_wos_self_order_detail: '自取件工单详情',
  main_menu_wos_board_return_order_detail: '海外退件未识别工单详情',
  main_menu_wos_board_transfer_order_detail: '中转拦截工单详情',
  main_menu_wos_board_exist_order_detail: '进出口工单详情',
  main_menu_wos_return_redispatch_channel: '退件重派渠道',
  main_menu_wos_abnormal_bill: '异常提单查询',
  main_menu_wos_my_work_order: '我的工单',
  main_menu_wos_oversea_piece: '海外段工单',
  main_menu_wos_work_question: '问题件',
  main_menu_wos_advice_complaint: '咨询/查件/投诉',
  main_menu_wos_advice_complaint_details: '咨询/查件/投诉详情',
  main_menu_wos_workbench_new: '工作台',
  main_menu_wos_other_order: '其他工单',
  // #endregion
  // #region 提成返点
  main_menu_crms_title: '提成返点',
  main_menu_crms_object_bind: '对象绑定管理',
  main_menu_crms_bill_data: '账单数据管理',
  main_menu_crms_rebate_bill: '返点账单管理',
  main_menu_crms_bill_download: '账单下载',
  main_menu_crms_rule_config: '规则配置管理',
  // #endregion
  // #region 网上订单管理
  main_menu_oms_order_list: '网上订单管理',
  // #endregion
  // #region 计划任务
  main_menu_cron_planing_list: '计划任务',
  // #endregion
  // #region 客户端管理
  main_menu_client_title: '客户端管理',
  main_menu_client_aisle: '通道列表',
  main_menu_client_instance: '实例列表',
  main_menu_client_key: '激活码列表',
  main_menu_client_apply: '申请列表',
  main_menu_client_apply_detail: '申请列表详情',
  main_menu_client_server: '服务端配置',
  // #endregion
  // #region 航空竞价
  main_menu_rbs_title: '航空竞价',
  main_menu_rbs_list: '竞价列表',
  main_menu_rbs_create_rule: '资源生成规则',
  main_menu_rbs_assess: '评估管理列表',
  main_menu_rbs_assess_details_post: '评估详情',
  main_menu_rbs_audit: '项目结果终审列表',
  main_menu_rbs_audit_details_post: '终审详情',
  main_menu_rbs_capacity: '项目资源管理列表',
  main_menu_rbs_capacity_resource_list: '资源列表详情',
  // #endregion
  // #region 前端词条管理
  main_menu_tsn_title: '前端词条管理',
  main_menu_tsn_system: '前端词条系统管理',
  main_menu_tsn_log: '前端词条维护日志',
  main_menu_tsn_translation: '前端词条列表',
  main_menu_tsn_wordstatistics: '前端词条统计',
  main_menu_tsn_basicData: '基础数据管理',
  // #endregion
  // #region 项目立项管理
  main_menu_pms_project_management_system: '项目管理系统',
  main_menu_pms_title: '项目立项管理',
  main_menu_pms_projectList: '项目列表',
  main_menu_pms_dashboard: '项目看板',
  main_menu_pms_projectList_form: '项目立项详情',
  main_menu_IT_portal: 'IT门户',
  main_menu_basic_framework: '基础框架管理系统',
  main_menu_customer_management_system: '客户积分管理系统',
  main_menu_route_login: '登录',
  main_menu_route_work_title: '工作台',
  main_menu_route_find_password: '找回密码',
  // #endregion
  // #region 网络规划
  main_menu_lnms_network_plan_management: '网络规划管理',
  main_menu_lnms_shift_manage: '班次管理',
  main_menu_lnms_collect_shift_manage: '揽收班次管理',
  main_menu_lnms_customs_shift_manage: '关务班次管理',
  main_menu_lnms_combination_shift_manage: '组合班次管理',
  main_menu_lnms_operation_shift_manage: '操作班次管理',
  main_menu_lnms_transport_shift_manage: '运输班次管理',
  main_menu_lnms_airline_shift_manage: '空运班次管理',
  main_menu_lnms_truck_shift_manage: '陆运班次管理',
  main_menu_lnms_delivery_shift_manage: '派送班次管理',
  main_menu_lnms_route_manage: '路由管理',
  main_menu_lnms_route_list: '路由列表',
  main_menu_lnms_product_route_list: '产品路由列表',
  main_menu_lnms_basic_data_list: '基础数据管理',
  main_menu_lnms_attribute_list: '属性管理',
  main_menu_lnms_constraint_list: '约束管理',
  main_menu_lnms_route_template_list: '线路模板管理',
  main_menu_lnms_direction_of_destination: '目的流向',
  main_menu_lnms_import_list: '导入列表',
  main_menu_lnms_export_list: '导出列表',
  // #endregion
  // #region 陆运管理系统
  main_menu_ltms_Land_transport_management_system: '陆运管理系统',
  main_menu_ltms_transportation_management: '运输管理',
  main_menu_ltms_transport_demand: '运输需求',
  main_menu_ltms_transport_order: '运输订单',
  main_menu_ltms_transport_task: '运输任务',
  main_menu_ltms_basic_data: '基础数据',
  main_menu_ltms_customer_management: '客户管理',
  main_menu_ltms_address_management: '地址管理',
  main_menu_ltms_carrier_management: '承运商管理',
  main_menu_ltms_carrier_priority_rules: '承运商优先级规则',
  main_menu_ltms_line_management: '线路管理',
  main_menu_ltms_carrier_quote: '承运商报价',
  main_menu_ltms_system_management: '系统管理',
  main_menu_ltms_platform_management: '平台管理',
  main_menu_ltms_mail_management: '邮件管理',
  main_menu_ltms_mail_list: '邮件列表',
  main_menu_ltms_mail_setting: '邮件配置',
  main_menu_ltms_check_bill: '账单核对',
  main_menu_ltms_estimated_cost: '预估费用',
  main_menu_ltms_import_bill: '账单导入',
  main_menu_ltms_bill_checked: '已核对账单',
  main_menu_ltms_evaluation_management: '询价管理',
  main_menu_ltms_tevaluation_demand: '询价需求',
  // #endregion
  // #endregion

  // #region Header
  main_header_recent_visit: '最近访问',
  main_header_placeholder: '搜索',
  main_header_IT_system: 'IT 系统',
  main_header_todo_center: '待办中心',
  main_header_message_remind: '消息提醒',
  // ABU拓展------↓
  main_header_full_screen: '全屏',
  main_header_forced_refresh: '刷新',
  // ABU拓展------↑
  main_header_change_SYS_password: '修改SYS密码',
  main_header_log_out: '退出登录',
  main_header_log_out_tip: '确认退出吗？',
  main_header_log_out_title: '退出提示',
  main_header_confirm: '确定',
  main_header_cancel: '取消',
  main_header_change_name: '姓名',
  main_header_change_Work_number: '工号',
  main_header_old_password: '旧密码',
  main_header_old_password_placeholder: '请输入初始密码',
  main_header_new_password: '新密码',
  main_header_new_password_placeholder: '请输入新密码',
  main_header_confirm_password: '确认密码',
  main_header_confirm_password_placeholder: '请确认密码',
  main_header_messageObj_prompt: '提示',
  main_header_messageObj_length: '密码长度需为8~16位',
  main_header_messageObj_three_condition: '需满足大小写字母、数字、特殊符号其中3种或以上',
  main_header_messageObj_no_repeat: '不允许连续或重复3位以上数字（如345、333）',
  main_header_messageObj_old_new_different: '新旧密码不能相同',
  main_header_messageObj_twice_different: '两次输入密码需一致',
  main_header_change_success: '修改成功',
  main_header_refresh: '刷新',
  main_header_close: '关闭',
  main_header_close_all: '全部关闭',
  main_header_close_addition: '除此之外全部关闭',
  main_header_close_right: '当前页右侧全部关闭',
  main_header_close_left: '当前页左侧全部关闭',
  // #endregion

  // #region 首页
  main_home_home_name: '首页',
  main_home_todo_title: '我的待办',
  main_home_todo_more: '更多',
  main_home_todo_checkAll: '全选',
  main_home_todo_batchProcess: '批量处理',
  main_home_todo_complaint: '转办',
  main_home_todo_approve: '审批通过',
  main_home_todo_reject: '驳回',
  main_home_todo_toDealWith: '去处理',
  main_home_todo_work_dealed: '恭喜你，你已处理完工作！',
  main_home_todo_no_data: '暂无数据',
  main_home_todo_current_select: '当前已选中',
  main_home_todo_data_num: '条数据',
  main_home_todo_all: '全部',
  main_home_todo_approve_tip: '该数据确定审批通过？',
  main_home_todo_approve_title: '审批通过',
  main_home_todo_confirm: '确定',
  main_home_todo_cancel: '取消',
  main_home_todo_approve_success: '审批通过！',
  main_home_todo_reject_title: '驳回处理',
  main_home_todo_reject_reason: '请填写驳回的原因',
  main_home_todo_reject_success: '驳回处理成功!',
  main_home_quick_title: '快捷入口',
  main_home_quick_create: '创建快捷',
  main_home_quick_cancel_common: '取消常用',
  main_home_quick_set_common: '设为常用',
  main_home_quick_sort: '排序',
  main_home_quick_recommend: '设为推荐应用',
  main_home_quick_add_common: '添加常用',
  main_home_quick_no_data: '暂无数据',
  main_home_quick_cancel_common_success: '取消常用成功！',
  main_home_quick_set_common_success: '设置常用成功！',
  main_home_quick_recommend_success: '设置为推荐应用成功！',
  main_home_report_transhipment: '转运-空运',
  main_home_report_no_data: '暂无数据',
  main_home_report_clearance: '关务-清关资料',
  main_home_report_risk_control: '关务-风控',
  // #endregion

  // #region request tips
  main_request_tip_exist_environ: '环境不存在',
  main_request_tip_login_expired: '登录已过期，请重新登录',
  main_request_tip_no_legal: '没有权限，请联系管理员',
  main_request_tip_server_error: '服务端错误，请联系管理员',
  main_request_504_error: '网关超时，请重试',
  main_request_tip_system_error: '系统错误，请联系管理员',
  main_request_tip_timeout: '请求超时，请刷新重试',
  main_request_copy_success: '复制成功',
  main_request_tip_confirm: '确定',
  main_request_tip_cancel: '取消',
  main_request_tip_delete_success: '删除成功',
  // #endregion

  // #region 登录、忘记密码
  main_login_welcome_system: '欢迎登录ABU运营系统',
  main_login_loading_failure: '环境加载失败，请刷新重试',
  main_login_morning_greetings: '早上好',
  main_login_noon_greetings: '中午好',
  main_login_afternoon_greetings: '下午好',
  main_login_night_greetings: '晚上好',
  main_login_account: '账号',
  main_login_placeholder_input: '请输入',
  main_login_password: '密码',
  main_login_retrieve_password: '找回密码',
  main_login_btn_text: '登录',
  main_login_account_tip: '请输入账号',
  main_login_password_tip: '请输入密码',
  main_login_accountMap_LDAP: '域',
  main_login_accountMap_SYS: '星云系统',
  main_login_accountMap_CAS: '纵腾内网',
  main_login_account_error: '账号密码错误',
  main_login_retrieve_back: '返回',
  main_login_select_account: '选择要找回的账号',
  main_login_select_way: '选择找回方式',
  main_login_authentication: '身份验证',
  main_login_reset_password: '重置密码',
  main_login_work_number: '工号',
  main_login_work_number_tip: '请输入要找回的工号',
  main_login_customer_tip: '您正在对',
  main_login_operation_tip: '进行重置密码操作',
  main_login_verification_code: '点击获取验证码，邮件将发送至邮箱',
  main_login_verification_code_tip: '请输入验证码',
  main_login_send_verification_code: '发送验证码',
  main_login_name: '姓名',
  main_login_new_password: '新密码',
  main_login_new_password_tip: '请输入新密码',
  main_login_new_password_again_tip: '再次输入新密码',
  main_login_next_step: '下一步',
  main_login_save: '保存',
  main_login_reset_password_succeeded: '重置密码成功，请重新登录',
  main_login_work_number_input: '请输入工号',
  main_login_six_verification_code: '请输入6位验证码',
  main_login_mail: '通过邮箱',
  main_login_unknown_way: '未知的验证方式',
  main_login_get_in: '正在进入系统，请耐心等待',
  main_login_no_exist_page: '您没权限或者该页面不存在',
  main_login_no_exist_page_tip: '请检查路径是否正确，或者点击按钮返回首页，如有问题请联系管理员',
  main_login_no_exist_back: '返回首页',
  main_login_no_last_back: '返回上一页',
  // #endregion

  // #region 物流控制塔-lct
  main_menu_lct: '物流控制塔',
  main_menu_lct_basic_data: '基础数据',
  main_menu_lct_ware_op: '库内操作时效标准',
  main_menu_lct_ware_tr: '仓间中转时效标准',
  main_menu_lct_ware_de: '仓库交货时效标准',
  main_menu_lct_flight_exce: '航班异常时效标准',
  main_menu_lct_noa_exce: 'NOA异常时效标准',
  main_menu_lct_customs_clear: '清关异常时效标准',
  main_menu_lct_pick_up: '提货异常时效标准',
  main_menu_lct_exce_type: '异常类型维护',
  main_menu_lct_exce_relation: '查看关系',
  main_menu_lct_report: '实时监控',
  main_menu_lct_report_port: '口岸转运监控',
  main_menu_lct_report_ware_work: '仓库运作监控',
  main_menu_lct_report_ware_tr: '仓间中转监控',
  main_menu_lct_report_de_service: '交服务商监控',
  main_menu_lct_report_overseas: '海外转运监控',
  main_menu_lct_report_exce: '运营分析',
  main_menu_lct_report_exce_ab: '异常提单监控',
  main_menu_lct_report_exce_type: '抵达到提取环节',
  main_menu_lct_flight_arrive: '航班抵达监控',
  main_menu_lct_pickup_notice: '提货通知监控',
  main_menu_lct_airport_pickup: '机场提货监控',
  main_menu_lct_pickup_in_warehouse: '提货入仓监控',
  main_menu_lct_clearance_link: '清关环节监控',
  main_menu_lct_oversea_all_link: '海外转运全链路监控',
  main_menu_lct_transfer_between_warehouse: '仓间中转监控',
  main_menu_lct_warehouse_work: '仓库运作监控',
  main_menu_lct_end_of_delivery: '交货末端监控',
  main_menu_lct_end_of_pickup: '末端提取监控',
  main_menu_lct_link_board: '监控看板',
  main_menu_lct_delivery_monitor: '妥投达标率报表',
  main_menu_lct_delivery_link_monitor: '妥投环节监控',
  main_menu_lct_delivery_to_arrive: '发货到抵达环节',
  main_menu_lct_take_off_monitor: '航班起飞监控',
  main_menu_lct_take_off_standard: '航班起飞时效标准',
  main_menu_lct_link_real_time_monitoring: '环节实时监控',
  main_menu_lct_run_analysis_report: '运营分析报表',
  main_menu_lct_aging_standard_configuration: '时效标准配置',
  main_menu_lct_pass_machine_standard: '过机发货时效标准',
  main_menu_lct_pass_machine_monitor: '过机发货监控',
  main_menu_lct_dispatch_arrive_monitor: '到港环节监控',
  main_menu_lct_dispatch_arrive_standard: '发货到港时效标准',
  main_menu_lct_pass_link: '过机环节监控',
  main_menu_lct_checkout_time_limit_standard: '签出过机时效标准',
  main_menu_lct_package_checkout_monitoring: '包裹签出监控',
  main_menu_lct_shared_monitoring: '共享质控日报表',
  // #endregion
  // #region 订单履约管理-ofp
  main_menu_ofp: '订单履约管理',
  main_menu_ofp_basic_info_manage: '基础信息管理',
  main_menu_ofp_task_manage: '任务管理',
  main_menu_ofp_e_directory_manage: '异常目录管理',
  main_menu_ofp_e_type_manage: '异常类型管理',
  main_menu_ofp_task_type_manage: '任务类型管理',
  main_menu_ofp_service_type_manage: '服务类型管理',
  main_menu_ofp_due_manage: '正向履约管理',
  main_menu_ofp_order_task_manage: '订单任务管理',
  main_menu_ofp_abnormal_ofp_manage: '异常履约管理',
  main_menu_ofp_e_task_manage: '异常任务管理',
  main_menu_ofp_e_task_details: '异常任务详情',
  main_menu_ofp_abnormal_manage: '异常管理',
  main_menu_ofp_block_import: '拦截导入',
  main_menu_ofp_e_task_query: '异常任务查询',
  main_menu_ofp_abnormal_manage_old: '异常管理(旧)',
  main_menu_ofp_e_task_query_old: '异常任务查询(旧)',
  main_menu_ofp_abnormal_details: '异常详情',
  main_menu_ofp_abnormal_details_old: '异常详情(旧)',
  main_menu_ofp_rules_manage: '履约规则管理',
  main_menu_ofp_e_process_manage: '异常流程管理',
  main_menu_ofp_edit_e_process: '编辑异常流程',
  main_menu_ofp_add_e_process: '新增异常流程',
  main_menu_ofp_view_e_process: '查看异常流程',
  main_menu_ofp_create_rules: '订单任务生成规则',
  main_menu_ofp_distribute_rules: '任务下发规则',
  main_menu_ofp_forward_task_manage: '正向任务管理',
  main_menu_ofp_process_processing: '履约流程处理',
  main_menu_ofp_process_processing_details: '流程处理详情',
  main_menu_ofp_task_instance: '履约任务实例',
  main_menu_ofp_task_instance_details: '任务实例详情',
  main_menu_ofp_performance_process_manage: '履约流程管理',
  main_menu_ofp_block_import_cancel: '拦截导入和取消',
  main_menu_ofp_import_detail_page: '拦截导入明细',
  // #endregion

  // #region 运输管理系统
  main_menu_tms_Transport_management_system: '运输管理系统',
  main_menu_tms_transportation_management: '运输管理',
  main_menu_tms_transport_demand: '运输需求',
  main_menu_tms_transport_order: '运输订单',
  main_menu_tms_transport_task: '运输任务',
  main_menu_tms_basic_data: '基础数据',
  main_menu_tms_line_management: '线路管理',
  main_menu_tms_mail_management: '邮件管理',
  main_menu_tms_mail_list: '邮件列表',
  main_menu_tms_mail_setting: '邮件配置',
  // #endregion

  // #region 运输资源管理系统
  main_menu_lrms_Land_resource_management_system: '运输资源管理系统',
  main_menu_lrms_basic_data: '基础数据',
  main_menu_lrms_address_management: '地址管理',
  main_menu_lrms_carrier_management: '承运商管理',
  main_menu_lrms_carrier_priority_rules: '承运商优先级规则',
  main_menu_lrms_carrier_quote: '承运商报价',
  main_menu_lrms_mail_management: '邮件管理',
  main_menu_lrms_mail_list: '邮件列表',
  main_menu_lrms_mail_setting: '邮件配置',
  main_menu_lrms_evaluation_management: '询价管理',
  main_menu_lrms_tevaluation_demand: '询价需求',
  // #endregion
  // #region 理赔系统
  main_menu_css_claims_reason: '配置赔偿原因',
  main_menu_css_region_setting: '配置大区及责任部门',
  main_menu_css_special_reason_setting: '理赔单维护',
  main_menu_css_special_reason_list: '特殊理赔列表',
  main_menu_css_customer_service: '客户服务',
  main_menu_css_basicdata_title: '基础数据',
  main_menu_css_claims_type: '配置赔偿类型',
  main_menu_css_import_record: '导推记录',
  main_menu_css_batch_import: '批量理赔单导入',
  main_menu_css_standard_list: '标准理赔列表',
  main_css_link_setting: '配置环节'
  // #endregion
}
